<template>
  <div class="concentrator-page" v-loading="loading">
    <div class="con-body">
      <div class="control-group">
        <div class="group-tip">根据您设置的策略，绑定到集中器上，集中器定时连通和断开</div>
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>新建策略</el-button
          >
        </div>
      </div>
      <div class="h20"></div>
      <table class="diy-table">
        <thead>
          <tr>
            <th width="280"><div class="cell">策略名称</div></th>
            <th width="140"><div class="cell">策略类型</div></th>
            <th width="140" ><div class="cell">策略型号</div></th>
            <th width="350"><div class="cell">绑定集控</div></th>
            <th width="140"><div class="cell">是否启用</div></th>
            <th width="200"><div class="cell">操作</div></th>
          </tr>
        </thead>
        <tbody>
          <template v-for="item in tableData">
            <tr>
              <td><div class="cell">{{item.strategy_name}}</div></td>
              <td><div class="cell">{{ strategyTypeList[item.strategy_type] }}</div></td>
              <td><div class="cell">{{ item.equipment_model }}</div></td>
              <td><div class="cell">{{ item.concentrator_names?item.concentrator_names:'-' }}</div></td>
              <td><div class="cell">
                <el-switch
                class="switch-texts"
                v-model="item.ste"
                :active-value="1"
                :inactive-value="2"
                active-text="启用"
                inactive-text="停用"
                active-color="#2d8cf0"
                inactive-color="#4d5967"
                @change="changeStates(item.id, $event)"
                />
                </div>
              </td>
              <td>
                <div class="cell">
                  <div class="table-last normal">
                    <span @click="(loading = true), openEditWin(item)" class="blue pointer mar-r15">编辑</span>
                    <span @click="delItem(item.id)" class="blue pointer">删除</span>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <div class="h20"></div>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>
    </div>

    <!--新增修改集控策略 开始-->
    <el-dialog
      v-if="dialogVisible"
      class="dialog860"
      :title="editType === 'create' ? '新增策略' : '编辑策略'"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="editOne"
        ref="editOneRef"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-row :gutter="20" class="item-list">
            <el-col :span="12">
              <el-form-item label="策略名称" prop="strategy_name">
                <el-input v-model="editOne.strategy_name" placeholder="请输入策略名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="策略类型">
                <el-select
                  placeholder="请选择策略类型"
                  v-model="editOne.strategy_type"
                  style="width: 100%"
                  @change="changeType"
                  :disabled="editType === 'create'?false:true"
                >
                  <el-option
                    v-for="(t,index) in filterSteList(strategyTypeList)"
                    :key="index"
                    :label="t"
                    :value="index+1"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设备型号">
                <el-select
                  placeholder="请选择设备型号"
                  v-model="editOne.equipment_model"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(t,index) in modelList"
                    :key="index"
                    :label="t"
                    :value="t"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="insert-strategy">
            <div class="sub-title">时间表</div>
            <ul class="t-head">
              <li class="bh">编号</li>
              <li class="loop">回路</li>
              <li class="time">【开-连通】时间</li>
              <li class="time">【关-断开】时间</li>
              <li class="handle">操作</li>
            </ul>
            <!-- startTime: this.numberToTime(0),
            endTime: this.numberToTime(3600) -->
            <div v-for="(item, index) in editOne.stg_explain" :key="item.key" class="item-box">
              <div class="item">
                <div class="bh">{{toOrder(index+1)}}</div>
                <div class="loop loop-box">
                  <span v-if="editOne.strategy_type==1">全部回路</span>
                  <el-select
                    v-else
                    placeholder="请选择回路"
                    v-model="item.loopNum"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="index in 6"
                      :key="index"
                      :label="`回路${index}`"
                      :value="index"
                    ></el-option>
                  </el-select>
                  
                </div>
                <div class="time">
                  <div class="line">
                    <el-time-picker
                      :name="'picker'+item.key+'_startTime'"
                      :clearable="false"
                      v-model="item.startTime"
                      format='HH:mm'
                      placeholder="任意时间点"
                      style="width: 100%"
                    >
                    </el-time-picker>
                  </div>
                </div>
                <div class="time">
                  <div class="line">
                    <el-time-picker
                      :name="'picker'+item.key+'_endTime'"
                      :clearable="false"
                      v-model="item.endTime"
                      format='HH:mm'
                      placeholder="任意时间点"
                      style="width: 100%"
                    >
                    </el-time-picker>
                  </div>
                </div>
                <div class="handle">
                  <div class="item-btn" @click="removeTime(index)"><i class="el-icon-remove"></i></div>
                  <div class="item-btn" @click="addTime"><i class="el-icon-circle-plus"></i></div>
                </div>
              </div>
            </div>

          </div>
      
          <div class="lamp-transfer strategy-transfer">
            <el-transfer
              filterable
              filter-placeholder="请输入集控编号或名称"
              :data="allDevices"
              :titles="['可选集控', '已选集控']"
              :button-texts="['删除到可选', '添加到已选']"
              v-model="allocated"
            >
            </el-transfer>
          </div>

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div class="box-footer">
          <el-button class="cancel-btn" size="medium" @click="dialogVisible = false">取消</el-button>
          <el-button v-if="editType === 'create'" type="primary" size="medium" @click="createItem">确定</el-button>
          <el-button v-if="editType === 'update'" type="primary" size="medium" @click="updateItem">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增修改集控策略 结束 -->
  </div>
</template>
<script>
import strategyApi from "@/api/concentrator/strategy"
import time from "@/utils/time";
import moment from "moment";
export default {
  props:['stgId'],
  data() {
    return {
      loading: false,
      modelList: ['TH6500','TH6600'],
      steList: ['', '启用', '停用'],
      runPositionList: ['', '云平台', '嵌入式设备'],
      strategyTypeList: ['', '集控策略', '回路策略'],
      tableData: [],
      pageInfo: {
        strategy_name: '',
        strategy_type: '',
        run_position: '',
        ste: '',
        page: 1,
        pageSize: 10
      },
      cnt_all: 0,
      dialogVisible: false,
      editOneRule: {
        title: [{ required: true, message: "请输入策略名称", trigger: "blur" }]
      },
      editType: -1,
      editOne: {
        id: '',
        strategy_name: '',
        strategy_type: 1,
        equipment_model: 'TH6500',
        stg_explain: [
          {
            key: Date.now(),
            loopNum: 0,
            startTime: this.numberToTime(0),
            endTime: this.numberToTime(3600)
          }
        ]
      },
      allDevices: [],
      allocated: []
    };
  },
  mounted() {
    this.getTableData(this.pageInfo.page)
    if(this.stgId){
      this.strategyInfo(this.stgId)
    }
  },
  methods: {
    ...time,
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex
      this.loading = true
      this.tableData = []
      strategyApi.strategyList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          const resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      })
    },
    strategyInfo(stgId) {
      strategyApi.getStrategyInfo(stgId).then((res) => {
        if (res.data.code === 1000) {
          let index = res.data.data
          if(index.id){
            this.editOne = {
              id: index.id,
              strategy_name: index.strategy_name,
              strategy_type: index.strategy_type,
              equipment_model:  index.equipment_model,
              stg_explain: []
            };
            this.editType = "update";
            this.getStgTime(index.id, index.stg_explain)
            this.getDeviceList('');
          }
        }
      })
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 10
      this.getTableData(1)
    },
    openEditWin(index) {
      this.allDevices = []
      this.allocated = []
      if (index === "create") {
        this.editOne = {
          id: '',
          strategy_name: '',
          strategy_type: 1,
          equipment_model: 'TH6500',
          stg_explain: [
            {
              key: Date.now(),
              loopNum: 0,
              startTime: this.numberToTime(0),
              endTime: this.numberToTime(3600)
            }
          ]
        }
        this.editType = "create";
        this.dialogVisible = true;
        this.loading = false;
      } else {
        this.editOne = {
          id: index.id,
          strategy_name: index.strategy_name,
          strategy_type: index.strategy_type,
          equipment_model: index.equipment_model,
          stg_explain: []
        };
        this.editType = "update";
        this.getStgTime(index.id, index.stg_explain)
      }
      this.getDeviceList('');
    },
    changeType(e) {
      this.editOne.stg_explain = []
      let stg_explain = {
        key: Date.now(),
        loopNum: e==1?0:'',
        startTime: this.numberToTime(0),
        endTime: this.numberToTime(3600)
      }
      this.$set(this.editOne.stg_explain, 0, stg_explain)
    },
    getStgTime(id, arr_str) {
      let arr = []
      if(arr_str){
        arr = JSON.parse(arr_str);
      }
      for (let i=0; i<arr.length; i++) {
        let item_one = {
          key: parseInt(id+'0'+i),
          loopNum: arr[i].loopNum,
          startTime: this.numberToTime(this.HmToNumber(arr[i].startTime)),
          endTime: this.numberToTime(this.HmToNumber(arr[i].endTime)),

        }
        this.$set(this.editOne.stg_explain, i, item_one)
      }
      this.dialogVisible = true
      this.loading = false
    },
    addTime() {
      this.editOne.stg_explain.push({
        key: Date.now(),
        loopNum: this.editOne.strategy_type==1?0:'',
        startTime: this.numberToTime(0),
        endTime: this.numberToTime(3600)
      })
    },
    removeTime(index) {
      if(this.editOne.stg_explain.length<=1){
        return this.$message.error('策略时间表至少存在一条！');
      }
      if (confirm("确定要删除这个时间段？")) {
        this.editOne.stg_explain.splice(index, 1);
      }
    },
    createItem() {
      this.$refs.editOneRef.validate((valid) => {
        if (valid) {
          const stg_explain = this.editOne.stg_explain
          if(stg_explain.length<1){
            return this.$message.error('策略时间表至少存在一条！');
          }

          let params = {
            strategy_name: this.editOne.strategy_name,
            strategy_type: this.editOne.strategy_type,
            equipment_model: this.editOne.equipment_model,
            stg_explain: [],
            cids: ''
          }

          if(this.allocated.length){
            params.cids = this.allocated.toString();
          }
          let newstg_explain= []
          for(let i =0; i<stg_explain.length; i++){
            const item_one = {
              loopNum: stg_explain[i].loopNum,
              startTime: moment(stg_explain[i].startTime).format("HH:mm"),
              endTime: moment(stg_explain[i].endTime).format("HH:mm")
            }
            newstg_explain[i] = item_one
          }
          params.stg_explain = JSON.stringify(newstg_explain);
          strategyApi.strategyAdd(params).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("添加成功");
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          })
        } else {
          return false
        }
      })

    },
    updateItem() {
      this.$refs.editOneRef.validate((valid) => {
        if (valid) {
          const stg_explain = this.editOne.stg_explain
          if(stg_explain.length<1){
            return this.$message.error('策略时间表至少存在一条！');
          }
          let params = {
            strategy_name: this.editOne.strategy_name,
            strategy_type: this.editOne.strategy_type,
            equipment_model: this.editOne.equipment_model,
            stg_explain: [],
            cids: ''
          }

          if(this.allocated.length){
            params.cids=this.allocated.toString();
          }

          let newstg_explain= []
          for(let i =0; i<stg_explain.length; i++){
            const item_one = {
              loopNum: stg_explain[i].loopNum,
              startTime: moment(stg_explain[i].startTime).format("HH:mm"),
              endTime: moment(stg_explain[i].endTime).format("HH:mm")
            }
            newstg_explain[i] = item_one
          }
          params.stg_explain = JSON.stringify(newstg_explain);
          strategyApi.strategyEdit(this.editOne.id, params).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("修改成功")
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          return false
        }
      })
    },  
    getDeviceList(id) {
      let that = this
      strategyApi.getSelectConcentrator({
        type: 1,
        is_support_offline_stg: 2,
        strategy_id: id
      }).then((res) => {
        if (res.data.code === 1000) {
          let arrData = []
          let resData = res.data.data 
          if(resData.length){
            for (const lamp of resData) {
              arrData.push({
                key: lamp.id,
                label: lamp.name+'-'+lamp.number
              })
            }
          }
          that.allocated = []
          if(id){
            if(arrData.length){
              for (const item of arrData) {
                that.allocated.push(item.key)
              }
              that.allDevices = [...that.allDevices, ...arrData]
              that.allDevices = Array.from(new Set(that.allDevices))
            }
          }else{
            that.allDevices = arrData
            if(that.editOne.id){
              that.getDeviceList(that.editOne.id)
            }
          }
        }
      })
    },

    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          strategyApi.strategyDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$popupMessage({
                type: 'success',
                title: "删除成功"
                // msg: '如果未刷新，请耐心等待5秒，点击刷新列表查看结果'
              })
              this.getTableData(this.pageInfo.page);
            } else {
              this.$popupMessage({
                type: 'error',
                title: "提示",
                msg: res.data.message,
              })
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getValue(value) {
      if (value == "1"||value == 1) {
        return "双灯模式";
      } else {
        return "单灯模式";
      }
    },
    toOrder(index){
      if(index<10){
        return '0'+index
      }else{
        return index
      }
    },
    filterSteList(list) {
      return list.filter((t, index) => index !== 0);
    },
    changeStates(id, value) {
      strategyApi.strategySwitch(id,{ ste: value }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(res.data.message);
          this.getTableData(this.pageInfo.page);
        }else{
          this.$message.error(res.data.message);
        }
      });
    }
  }
}
</script>

<style lang='less'>
.concentrator-page{
  padding:0 0 20px;
  .con-table{
    padding-bottom: 20px;
  }
  .diy-table{
    width:100%;
    border: 0;
    border-collapse: collapse;
    border-spacing: 0;
    color: #1d2129;
    tr{
      margin:0;
      padding: 0;
      border: 0;
      th,td{
        border: 0;
        border-right: 1px solid #dee0e4;
        border-bottom: 1px solid #dee0e4;
        padding: 20px 0;
        min-width: 0;
        word-break: break-all;
        box-sizing: border-box;
        text-overflow: ellipsis;
        vertical-align: middle;
        position: relative;
        background-clip: padding-box; /* Add this line */
        .cell{
          box-sizing: border-box;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          word-break: break-all;
          line-height: 1.4;
          padding:5px 10px;
          font-size: 14px;
          text-align: center;
          &.times{
            display: flex;
            align-items: center;
            justify-content: center;
            .icon{
              margin: 0 20px;
              font-weight: normal;
            }
          }
        }
        &:last-child{
          border-right: 1px solid transparent;
        }
      }
      
      th{
        background-color: #f5f7f9;
        border-right: 1px solid #f5f7f9;
        border-bottom: 1px solid #dee0e4;
        .cell{
          font-size: 16px;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      td{
        .time1{
          width:140px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .time2{
          width:140px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .icon{
          color:#bbb;
        }
      }

      
      &.sub-tr{
        td{
          &:last-child{
            border-right: 1px solid #dee0e4;
          }
        }
      }
      &.double0{
        td{
          background-color: rgba(246,255,255,.6);
        }
      }
    }
  }
  .insert-strategy{
    color:#1d2129;
    padding-bottom: 20px;
    .sub-title{
      padding-bottom: 15px;
    }
    .t-head{
      width:100%;
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
      background-color: #f6f7fb;
      box-sizing: border-box;
      border-right:1px solid #f6f7fb;
      li{
        height:40px;
        display: flex;
        align-items: center;
        justify-content: center;
        &.bh{
          width:60px;
        }
        &.loop{
          width:140px;
        }
        &.time{
          flex: 1;
          min-width: 150px;
        }
        &.handle{
          width:150px;
        }
      }
    }

    .item-box{
      width:100%;
      border-bottom: 1px solid #dcdee2;
      .item{
        height:40px;
        display: flex;
        .bh{
          width:60px;
          height:40px;
          border-right:1px solid #dcdee2;
          display:flex;
          align-items:center;
          justify-content:center;
          padding:0 10px;
          box-sizing: border-box;
        }
        .loop{
          width:140px;
          height:40px;
          border-right:1px solid #dcdee2;
          display:flex;
          align-items:center;
          justify-content:center;
          padding:0 10px;
          box-sizing: border-box;
          .el-input__inner{
            border: 0;
          }
        }
        .time{
          flex: 1;
          min-width: 150px;
          height:40px;
          border-right:1px solid #dcdee2;
          display:flex;
          align-items:center;
          justify-content:center;
          padding:0 10px;
          box-sizing: border-box;
        }
        .handle{
          width:150px;
          height:40px;
          border-right:1px solid #fff;
          display:flex;
          align-items:center;
          justify-content:center;
          padding:0 10px;
          box-sizing: border-box;
          .item-btn{
            width:25px;
            height:25px;
            color:#2d8cf0;
            font-size:22px;
            display:flex;
            align-items:center;
            justify-content:center;
            cursor:pointer;
            margin:0 8px;
          }
        }
      }
    }
  }
  .time{
    .el-input__inner{
      border:0;
      position:relative;
      text-align: center;
    }
    .el-icon-time{
      margin-top:1px;
      display: none;
    }
  }
  .strategy-transfer{
    .el-transfer__buttons{
      .el-transfer__button{
        left:100px !important;
        &:first-child{
          left: auto !important;
          right:100px !important;
        }
      }
    }
  }
}
</style>
